export default __webpack_public_path__ + "static/media/noticia_exemplo1.4b455d08.jpg";